export var version = '1.12.1';